import * as types from './mutation-types';
import strainsService from '../../services/strains'
import harvestScheduleService from '../../services/harvestSchedule'
import yieldPerformanceService from '../../services/yieldPerformance'
import { createServiceCall } from '../actionsUtil'

export const getStrains = createServiceCall({
  mainAction: types.GET_STRAINS_REQUEST,
  serviceFunction: strainsService.getStrains,
  successAction: types.GET_STRAINS_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_STRAINS_FAILURE
})

export const getHarvestSchedule = createServiceCall({
  mainAction: types.GET_HARVEST_SCHEDULE_REQUEST,
  serviceFunction: harvestScheduleService.getHarvestSchedule,
  successAction: types.GET_HARVEST_SCHEDULE_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_HARVEST_SCHEDULE_FAILURE
})

export const getMonthlyTotalYieldByStrain = createServiceCall({
  mainAction: types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_REQUEST,
  serviceFunction: yieldPerformanceService.getMonthlyTotalYieldByStrain,
  successAction: types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_FAILURE
})

export const getMonthlyTotalYield = createServiceCall({
  mainAction: types.GET_MONTHLY_TOTAL_YIELD_REQUEST,
  serviceFunction: yieldPerformanceService.getMonthlyTotalYield,
  successAction: types.GET_MONTHLY_TOTAL_YIELD_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_MONTHLY_TOTAL_YIELD_FAILURE
})

export const getInFlight = createServiceCall({
  mainAction: types.GET_IN_FLIGHT_REQUEST,
  serviceFunction: yieldPerformanceService.getInFlight,
  successAction: types.GET_IN_FLIGHT_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_IN_FLIGHT_FAILURE
})
